(() => {
  const storageKey = "happyneon_wishlist_v1";
  const countElements = document.querySelectorAll("[data-happyneon-wishlist-count]");

  const readWishlist = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(storageKey) || "[]");
      return Array.isArray(value) ? [...new Set(value.filter(Boolean))] : [];
    } catch {
      return [];
    }
  };

  const updateCount = () => {
    const wishlist = readWishlist();
    const count = wishlist.length;
    countElements.forEach((element) => {
      element.textContent = String(count);
      element.hidden = count === 0;
    });
    document.querySelectorAll("[data-happyneon-wishlist-toggle]").forEach((button) => {
      button.setAttribute(
        "aria-pressed",
        String(wishlist.includes(button.dataset.happyneonWishlistToggle))
      );
    });
  };

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-happyneon-wishlist-toggle]");
    if (!button) return;
    event.preventDefault();
    const handle = button.dataset.happyneonWishlistToggle;
    const wishlist = readWishlist();
    const nextWishlist = wishlist.includes(handle)
      ? wishlist.filter((item) => item !== handle)
      : [...wishlist, handle];
    window.localStorage.setItem(storageKey, JSON.stringify(nextWishlist));
    document.dispatchEvent(new CustomEvent("happyneon:wishlist-change"));
  });

  updateCount();
  window.addEventListener("storage", updateCount);
  document.addEventListener("happyneon:wishlist-change", updateCount);
})();
